import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {authenticate} from "../../services/controlPanelApi";
import {toast } from "react-toastify";
import Spinner from "../Spinner/Spinner";

const Welcoming = ({ onAccessGranted }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);

    const handlePasswordSubmit = async () => {
        setLoading(true);
        setError('');

        try {
            await authenticate(password);
            onAccessGranted()
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
            if (err !== undefined && err.response !== undefined) {
                if (err.response.status === 403) {
                    toast.error('Contraseña incorrecta. Inténtalo de nuevo.');
                    return setError('Contraseña incorrecta. Inténtalo de nuevo.');
                }
                if (err.response.status === 401) {
                    toast.error('Acceso denegado.');
                    return setError('Acceso denegado.');
                }
            }
            toast.error('Error al validar la contraseña. Inténtalo más tarde.');
            setError('Error al validar la contraseña. Inténtalo más tarde.');
        }
    };

    return (
        <div className="container">
            {loading && (
                <Spinner />
            )}
            <div className="card">
                <h1>Bienvenido</h1>
                <div >
                    <input
                        className="form-control"
                        style={{marginBottom:"10px"}}
                        type="password"
                        placeholder="Ingrese la contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
                    <button type="submit" onClick={() => handlePasswordSubmit()} className="btn btn-red">
                        Entrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Welcoming;
